(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-range-buttons"] && !Shopify.designMode) return;
  try {
    class PriceRangeButtons extends HTMLElement {
    connectedCallback() {
      this.minParam = this.dataset.minParam;
      this.maxParam = this.dataset.maxParam;

      // Inline buttons
      this.querySelectorAll('.price-range-buttons__button').forEach(button => {
        button.addEventListener('click', this.handleButtonClick.bind(this));
      });

      // Drawer checkboxes
      this.querySelectorAll('.checkbox').forEach(checkbox => {
        const input = checkbox.querySelector('.checkbox__input');
        if (input) {
          input.addEventListener('change', (e) => this.handleCheckboxClick(e, checkbox));
        }
      });
    }

    handleButtonClick(event) {
      const button = event.currentTarget;
      this.#applyFilter(button.dataset);
    }

    handleCheckboxClick(event, checkbox) {
      // Uncheck all other checkboxes in this group
      this.querySelectorAll('.checkbox__input').forEach(input => {
        if (input !== event.target) {
          input.checked = false;
        }
      });
      // Ensure the clicked one stays checked
      event.target.checked = true;

      this.#applyFilter(checkbox.dataset);
    }

    #applyFilter(data) {
      const isClear = data.clear === 'true';
      const minValue = data.min;
      const maxValue = data.max;

      const url = new URL(window.location.href);

      url.searchParams.delete(this.minParam);
      url.searchParams.delete(this.maxParam);

      if (!isClear) {
        if (minValue) url.searchParams.set(this.minParam, minValue);
        if (maxValue) url.searchParams.set(this.maxParam, maxValue);
      }

      url.searchParams.delete('page');

      const facetsForm = this.closest('facets-form-component') || document.querySelector('facets-form-component');
      if (facetsForm && typeof facetsForm.updateFiltersByURL === 'function') {
        facetsForm.updateFiltersByURL(url.toString());
      } else {
        window.location.href = url.toString();
      }
    }
  }

  if (!customElements.get('price-range-buttons')) {
    customElements.define('price-range-buttons', PriceRangeButtons);
  }
  } catch(e) { console.error(e); }
})();

})();
